var _title, _defs, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIcDt = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Group 6")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.75,44.9203846 L24.75,31.2376154 L25.7137615,30.8682692 C28.0837385,29.9412692 29.9295,28.1128846 30.8565,25.8151154 L30.8782385,25.7541923 L31.2525,24.8033077 L44.9505,24.8033077 L44.6227615,26.5763077 C42.8632615,35.7621923 35.7150115,42.8832692 26.65575,44.5797692 L26.51625,44.6015769 L24.75,44.9203846 Z M27.7500115,33.2525769 L27.7500115,41.2445769 C34.2862615,39.3545769 39.3359885,34.3273846 41.22225,27.9425769 L41.2574885,27.8041154 L33.2474885,27.8041154 C32.04225,30.1842692 30.1440115,32.067 27.8204885,33.2210769 L27.7507385,33.2525769 L27.7500115,33.2525769 Z M20.1562615,44.9106923 L18.3832615,44.5828846 C7.731,42.6125769 0,33.3083077 0,22.4601923 C0,11.6120769 7.73176154,2.30780769 18.3832615,0.3375 L20.1562615,0.00969230769 L20.1562615,13.7076923 L19.2052385,14.0818846 C15.8355,15.435 13.5,18.675 13.5,22.4601923 C13.5,26.2453846 15.8362615,29.4853846 19.14525,30.8166923 L19.206,30.8385 L20.1569885,31.2126923 L20.1562615,44.9106923 Z M17.15625,3.70107692 C8.91675,6.1065 3.00001154,13.5920769 3.00001154,22.4601923 C3.00001154,31.3283077 8.91675,38.8138846 17.0182385,41.1846923 L17.15625,41.2193077 L17.15625,33.2075769 C13.1790115,31.1960769 10.4999885,27.1408846 10.4999885,22.4601923 C10.4999885,17.7795 13.1790115,13.7243077 17.0879885,11.7443077 L17.15625,11.7128077 L17.15625,3.70107692 Z M44.9602615,20.2101923 L31.27725,20.2101923 L30.90825,19.2465 C29.97225,16.8493846 28.1107385,14.9881154 25.7752385,14.0728846 L25.7137615,14.0521154 L24.75,13.6827692 L24.75,0 L26.51625,0.318807692 C35.7494885,2.043 42.9179885,9.2115 44.6205115,18.3053077 L44.64225,18.4448077 L44.9602615,20.2101923 Z M33.2924885,17.2100769 L41.2844885,17.2100769 C39.3892615,10.6400769 34.3200115,5.571 27.8879885,3.71007692 L27.7500115,3.67580769 L27.7500115,11.6678077 C30.17475,12.8675769 32.0925115,14.7856154 33.2609885,17.1405 L33.2924885,17.2100769 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Reports-Final-with-actual-content",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Report-Landing",
    transform: "translate(-737.000000, -300.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-33",
    transform: "translate(238.000000, 154.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "modules",
    transform: "translate(60.999988, 122.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-29",
    transform: "translate(414.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(24.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-862"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-861",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "-17.3076923 -17.3076923 62.2679538 -17.3076923 62.2679538 62.2280769 -17.3076923 62.2280769"
  })))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcDt, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic_DT.2e554e7b.svg";
export { ForwardRef as ReactComponent };